import { List, Record } from '../immutable';
export var Module = Record({
  name: null,
  state: List(),
  effects: List(),
  middleware: List(),
  subscribers: List(),
  storeEnhancers: List(),
  dependencies: List(),
  params: null,
  combine: null
}); // todo make router combine get executed by compose-app